import FixaHelperText from "@coworker/apprestructured/src/shared/wrappers/FixaHelperText/FixaHelperText";
import { ReactNode } from "react";

type ErrorAddOnProps = {
  children: ReactNode;
};

function ErrorAddOn({ children }: ErrorAddOnProps) {
  return <FixaHelperText shouldValidate={true}>{children}</FixaHelperText>;
}

export default ErrorAddOn;
